function isRemapName(value) {
  return typeof value === "string" && value !== "";
}

function partitionContextBindings(bindings, requiredNames = []) {
  const source = bindings && typeof bindings === "object" ? bindings : {};
  const required = new Set((requiredNames ?? []).filter(Boolean));

  const survivors = new Set();
  Object.keys(source).forEach(name => {
    if (required.has(name)) {
      survivors.add(name);
    }
  });

  // A required name may point at ANOTHER binding by bare string (the legacy
  // remap form: { theButtonCardStory: "myStory", myStory: {...} }). The target
  // is not itself required, so a naive prune deletes the entity the remap
  // resolves through and silently empties the component.
  let grew = true;
  while (grew) {
    grew = false;
    [...survivors].forEach(name => {
      const target = source[name];
      if (isRemapName(target) && source[target] !== undefined && !survivors.has(target)) {
        survivors.add(target);
        grew = true;
      }
    });
  }

  const kept = {};
  const discarded = {};
  Object.entries(source).forEach(([name, binding]) => {
    if (survivors.has(name)) {
      kept[name] = binding;
      return;
    }
    discarded[name] = binding;
  });
  return { kept, discarded };
}

module.exports = { partitionContextBindings };
module.exports.default = { partitionContextBindings };
